import { type UseQueryResult, useQuery } from 'react-query';
import { SupportContactService } from '../../services/wealthlane-customer-services/services/SupportContactService';
import { Wealthlane_CustomerService_Dtos_SupportContact_SupportContactDto } from '../../services/wealthlane-customer-services/models/Wealthlane_CustomerService_Dtos_SupportContact_SupportContactDto';

const useGetSupportContactByCompanyId = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  companyId: string,
  hasManageAlertSubscription: boolean
): UseQueryResult<
  // eslint-disable-next-line camelcase
  Wealthlane_CustomerService_Dtos_SupportContact_SupportContactDto[] | undefined,
  unknown
> => {
  const supportContactByCompanyId = useQuery(
    ['getSupportContactByCompanyId', companyId, hasManageAlertSubscription],
    async () => {
      if (companyId) {
        return await handleRequest(
          SupportContactService.getApiCustomerApiAppSupportContactSupportContactsByCompanyId(
            companyId
          )
        );
      }
    },
    {
      enabled: hasManageAlertSubscription,
    }
  );

  return supportContactByCompanyId;
};

export default useGetSupportContactByCompanyId;
